import React, { ReactElement } from 'react';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import {
  gray40,
  gray80,
  primaryButtonBackgroundColor,
  tertiaryButtonBackgroundColor,
} from '../../../constants/colors';
import { boldMd, regularLg, regularXl } from '../../../constants/location';
import { useProxyDialogSx } from '../../../hooks/useProxyDialogSx';

type Props = {
  open: boolean;
  onClose: () => void;
  onSend: () => void;
  title: string;
};

const styles = {
  buttonWrapper: {
    display: 'flex',
    gap: '16px',
    marginTop: '32px',
    '@media screen and (max-width:960px)': {
      gap: '8px',
      marginTop: '20px',
    },
  },
  cancelButton: {
    ...tertiaryButtonBackgroundColor,
    height: '44px',
    width: 'calc(50% - 8px)',
    '@media screen and (max-width:960px)': {
      width: 'calc(50% - 4px)',
    },
  },
  cancelButtonText: {
    ...boldMd,
    color: gray80,
  },
  deleteButton: {
    height: '44px',
    width: 'calc(50% - 8px)',
    ...primaryButtonBackgroundColor,
  },
  deleteButtonText: {
    ...boldMd,
    color: 'white',
  },
  dialog: {
    '& .MuiPaper-root': {
      border: '1px solid' + gray40,
      boxSizing: 'border-box',
      margin: '16px',
      padding: '40px',
      '@media screen and (max-width: 960px)': {
        padding: '32px 16px',
      },
    },
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
    '@media screen and (max-width:960px)': {
      marginBottom: '16px',
    },
  },
  icon: {
    height: '32px',
    width: '32px',
    '@media screen and (max-width:960px)': {
      height: '24px',
      width: '24px',
    },
  },
  iconButton: {
    padding: 0,
  },
  title: {
    ...regularXl,
    '@media screen and (max-width:960px)': {
      ...regularLg,
    },
  },
};

const ReSendInviteMailModal = ({ open, onClose, onSend, title }: Props): ReactElement => {
  const proxyDialogSx = useProxyDialogSx();

  return (
    <Dialog open={open} sx={[styles.dialog, proxyDialogSx]}>
      <Box sx={styles.header}>
        <Typography sx={styles.title}>招待メールを再送</Typography>
        <IconButton onClick={onClose} sx={styles.iconButton}>
          <Close sx={styles.icon} />
        </IconButton>
      </Box>
      <Typography>{title}へ招待メールを再送します。</Typography>
      <Box sx={styles.buttonWrapper}>
        <Button sx={styles.cancelButton} onClick={onClose}>
          <Typography sx={styles.cancelButtonText}>キャンセル</Typography>
        </Button>
        <Button sx={styles.deleteButton} onClick={onSend}>
          <Typography sx={styles.deleteButtonText}>送信する</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default ReSendInviteMailModal;
